import { EnvironmentsAPI } from "../../providers/EnvironmentsAPI";
import { EnvironmentStorage } from "./EnvironmentStorage";
import { Storage } from "./Storage";

export class ThemeLoader {
  static async init() {
    const environmentId = EnvironmentStorage.getSelectedEnvironment();
    if (environmentId) {
      const theme =
        (await EnvironmentsAPI.getConfigurationsByAlias(
          environmentId,
          "theme"
        )) || {};

      if (!theme?.primaryColor && !theme?.secondaryColor && !theme?.logo) {
        Storage.setItem("theme", {
          logo: "/fav-olga.png",
          primaryColor: "#616ff3",
          secondaryColor: "#616ff3",
        });
      } else {
        if (theme.logo) {
          theme.logo = `${process.env.REACT_APP_ASSETS_URL}/${theme.logo}`;
        }
        Storage.setItem("theme", theme);
      }
    } else {
      Storage.setItem("theme", {
        logo: "/fav-olga.png",
        primaryColor: "#616ff3",
        secondaryColor: "#616ff3",
      });
    }

    ThemeLoader.loadTheme();
  }

  static loadTheme() {
    const theme = Storage.getItem("theme");
    window.adminLogo = theme.logo;
    window.primaryColor = "#616ff3";
    window.secondaryColor = "#616ff3";
    window.dispatchEvent(new Event("themeChanged", { details: theme }));
  }

  static onThemeChanged(listener) {
    window.addEventListener("themeChanged", listener);
  }

  static removeOnThemeChanged(listener) {
    window.removeEventListener("themeChanged", listener);
  }
}
